import { render, staticRenderFns } from "./BusDataSyncBaseSetList.vue?vue&type=template&id=2c565029&scoped=true&"
import script from "./BusDataSyncBaseSetList.vue?vue&type=script&lang=js&"
export * from "./BusDataSyncBaseSetList.vue?vue&type=script&lang=js&"
import style0 from "./BusDataSyncBaseSetList.vue?vue&type=style&index=0&id=2c565029&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c565029",
  null
  
)

export default component.exports